import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {User} from '@models/user';
import {Store} from '@ngrx/store';
import * as AuthReducer from '@store/auth/reducers';
import * as SpinnerReducer from '@store/spinner/reducers';
import {Observable} from 'rxjs';
import {AuthFacade} from '@facades/auth/authFacade';
import {OnDestroy} from '@node_modules/@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProgramService implements OnDestroy{
  subscribes = [];
  user: User;

  constructor(
    private httpClient: HttpClient,
    private authStore: Store<AuthReducer.AuthState>,
    private spinnerStore: Store<SpinnerReducer.SpinnerState>,
    private store: Store<SpinnerReducer.SpinnerState>
  ) {
    this.subscribes.push(this.authStore.subscribe(
      (val) => {
        const user = AuthFacade.getUser();
        // console.log(user);
        if (user) {
          this.user = user;
        }
      }
    ));
  }
  ngOnDestroy() {
    this.unsubscribe();
  }
  create(body) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.post(school_id + '/program' , body);
    }
    return new Observable();
  }
  deleteProgram(program_id, force) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      const url = school_id + '/program/' + program_id;
      return this.httpClient.delete(force ? url + '/f': url );
    }
    return new Observable();
  }
  edit(body) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.put(school_id + '/program' , body);
    }
    return new Observable();
  }

  /**
   *  Get programs of the school
   *  Param 'schoolId' is used for not authenticated queries
   * @param user
   * @param ids
   * @param schoolId
   */
  getAll(user = null, ids = [], schoolId = null) {
   this.user = user ? user : this.user;
    const school_id = this.user && this.user.activeSchool ? this.user.activeSchool : schoolId;
    if (school_id) {
      const prefix = schoolId ? 'school/' : '';
      return this.httpClient.get(prefix + school_id + '/program/');
    }
    let idsS = '';
    if (ids.length > 0) {
      idsS += '?ids=' + ids.join(',');
      return this.httpClient.get('program' + idsS);
    }
    return new Observable();
  }
  getProgamByIds(ids, trial, user_id) {
    let idsS = '';
    if (ids && ids.length > 0) {
      idsS += '?ids=' + ids.join(',');
      if (trial && user_id) {
        idsS += '&trial=' + trial + '&user_id=' + user_id;
      }
      return this.httpClient.get('program' + idsS);
    }
    return new Observable();
  }
  getProgram(program_id) {
      return this.httpClient.get('programInfo/' + program_id);
  }

  getUsersPrograms(schoolId = null) {
    return this.httpClient.get('program/programUser' + (schoolId ? '/' + schoolId : ''));
  }
  getSchoolPrograms(program_id) {
    return this.httpClient.get('program/programClass/' + program_id);
  }
  getSchoolOwner(programIds: number[], programId = null, classId = null) {
    if (programIds && programIds.length > 0) {
      let url = 'program/schoolOwner?ids=' + programIds.join(',');
      if (programId) {
        url += '&program_id=' + programId;
      }
      if (classId) {
        url += '&class_id=' + classId;
      }
      return this.httpClient.get(url);
    }
    return new Observable();
  }
  getProgramsByCurriculum(curriculum_id) {
    return this.httpClient.get('program/programCurriculum/' + curriculum_id);
  }
  setProgramUser( user_id: number, program_id: number) {
    return this.httpClient.post('program/programUser', {program_id: program_id, user_id: user_id});
  }

  addUser(body) {
    // this.store.dispatch(new StartSpinner());
    return this.httpClient.post( 'program/user' , body);
  }

  validateUserName(body){
    return this.httpClient.post( 'validators/user-name' , body);
  }

  deleteUser(body: {user_id: number, program_id: number}) {
      return this.httpClient.delete('program/user/'+body.user_id+'/'+body.program_id);
  }
  toggleUserInTheProgram(body, deleteUser = false) {
    if (deleteUser === true) {
      return this.deleteUser(body);
    } else {
      return this.addUser(body);
    }
  }
  inviteUser(body) {
    if (this.user.activeSchool) {
      const school_id = this.user.activeSchool;
      return this.httpClient.post(school_id + '/program/invite' , body);
    }
    return new Observable();
  }
  search(value: string) {
    return this.httpClient.get('program/search?value=' + value);
  }
  getStudents(programId: number) {
    return this.httpClient.get(`program/${programId}`);
  }
  unsubscribe() {
    this.subscribes.map( subscr => {
      subscr.unsubscribe();
    });
  }

  updateVisibility(schoolId, programId, isPrivate) {
    return this.httpClient.put(`${schoolId}/program/${programId}/visibility`, {
      "private": isPrivate
    });
  }
}
